import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import classnames from "classnames";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CircularProgress_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else CircularProgress_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const CircularProgress_CircularProgress = (t0)=>{
    const $ = c(12);
    let className;
    let color;
    let rest;
    let size;
    if ($[0] !== t0) {
        ({ size, color, className } = t0), rest = _object_without_properties(t0, [
            "size",
            "color",
            "className"
        ]);
        $[0] = t0;
        $[1] = className;
        $[2] = color;
        $[3] = rest;
        $[4] = size;
    } else {
        className = $[1];
        color = $[2];
        rest = $[3];
        size = $[4];
    }
    let t1;
    if ($[5] !== className) {
        t1 = classnames(className, "aqa_circular_progress");
        $[5] = className;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== color || $[8] !== rest || $[9] !== size || $[10] !== t1) {
        t2 = /*#__PURE__*/ jsx(CircularProgress, _object_spread_props(_object_spread({}, rest), {
            "data-testid": "circular-progress",
            color: color,
            size: size,
            className: t1
        }));
        $[7] = color;
        $[8] = rest;
        $[9] = size;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
export { CircularProgress_CircularProgress as CircularProgress };
